export default function shouldUseMSW() {
  return (
    process.env.NEXT_PUBLIC_USE_MOCK_API === 'true' ||
    process.env.STORYBOOK === 'true' ||
    process.env.CYPRESS === 'true' ||
    process.env.NODE_ENV === 'test'
  );
}
